/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Toolbar Live History Icon component.
 */
export const MapToolbarLiveHistoryIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_16019_9456)'>
        <path d='M5.64992 7.42491C6.40402 5.56623 7.79267 4.0351 9.5691 3.10361C11.3455 2.17211 13.3947 1.9006 15.3524 2.33731C17.3101 2.77402 19.0496 3.89066 20.2617 5.48881C21.4739 7.08697 22.0802 9.06311 21.9728 11.0661C21.8655 13.069 21.0515 14.9691 19.6756 16.4286C18.2996 17.8881 16.4508 18.8124 14.4576 19.0375' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M13.165 7.00023L13.1666 11.2532L16.1097 13.4061' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M8.34161 8.20057L5.2471 8.06692L4.604 5.32786' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M10.6301 12.4333C10.7138 12.0402 10.3228 11.714 9.95099 11.8668L2.68956 14.8512C2.22045 15.044 2.30334 15.7322 2.80481 15.8081L6.4424 16.3586C6.62661 16.3865 6.78004 16.5145 6.84051 16.6907L8.0346 20.1706C8.19922 20.6503 8.89106 20.6084 8.99659 20.1123L10.6301 12.4333Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_16019_9456'>
          <rect width='21.9983' height='21.9983' fill={dlsColor('white')} transform='translate(1.00146 1.00951) rotate(-0.0215263)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapToolbarLiveHistoryIcon;
